import { Button, Stack } from '@razz-team/ui-web';
import { useTranslation } from 'react-i18next';
import { useUpdateStandingOrderStatusMutation } from '../../../api/standing-orders';
import { ApiStandingOrder } from '../../../openapi';
import { useCallback } from 'react';

export function StandingOrderStatusActions({
  order,
  onTerminate,
}: {
  order: ApiStandingOrder;
  onTerminate: () => void;
}) {
  const { t } = useTranslation();

  const updateStatusMutation = useUpdateStandingOrderStatusMutation({ orderId: order.id });

  const handleActivate = useCallback(() => {
    if (!updateStatusMutation.isPending) {
      updateStatusMutation.mutate({ status: 'ACTIVATED' });
    }
  }, [updateStatusMutation]);

  const handleSuspend = useCallback(() => {
    if (!updateStatusMutation.isPending) {
      updateStatusMutation.mutate({ status: 'SUSPENDED' });
    }
  }, [updateStatusMutation]);

  const isActivating =
    updateStatusMutation.isPending && updateStatusMutation.variables?.status === 'ACTIVATED';
  const isSuspending =
    updateStatusMutation.isPending && updateStatusMutation.variables?.status === 'SUSPENDED';

  switch (order.status) {
    case 'ACTIVATED':
      return (
        <Button onClick={handleSuspend} loading={isSuspending} variant="outlined" size="small">
          {t('Suspend')}
        </Button>
      );
    case 'SUSPENDED':
      return (
        <Stack direction="row" spacing={1}>
          <Button onClick={handleActivate} loading={isActivating} variant="outlined" size="small">
            {t('Activate')}
          </Button>
          <Button onClick={onTerminate} variant="outlined" color="error" size="small">
            {t('Terminate')}
          </Button>
        </Stack>
      );
    case 'TERMINATED':
      return null;
    default:
      return null;
  }
}
